import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Field from '../common/FormField'
import PasswordStrengthRules from '../common/PasswordStrengthRules'
import styles from './common.module.css'

function ResetPasswordForm({ onChangeFactory, inProgress, error, onSubmit, tokenMissing }) {
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [passwordValue, setPasswordValue] = useState('')

  const handlePasswordChange = e => {
    setPasswordValue(e.target.value)
    onChangeFactory('password')(e)
  }

  if (tokenMissing) {
    return (
      <div className={styles.errorMessage}>
        <header>Invalid Reset Link</header>
        <div className={styles.successBody}>
          <i className="fa fa-exclamation-circle" style={{ fontSize: 40, color: '#e74c3c', marginBottom: 16, display: 'block' }} />
          <p>
            This password reset link is invalid or has expired. Please request a new one.
          </p>
          <div className={styles.successActions}>
            <Link to="/forgot-password" className={`btn btn-primary ${styles.submitButton}`}>
              Request New Link
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <form
      id="reset-password-form"
      className="smart-form client-form"
      noValidate
      onSubmit={event => {
        event.preventDefault()
        onSubmit(event)
      }}
    >
      <header>Reset Password</header>
      <fieldset>
        <div className={styles.intro}>
          Enter your new password below.
        </div>

        {error && error.token && (
          <div className={styles.loginErrorMsg} role="alert">
            {error.token}
          </div>
        )}

        {error && error.message && (
          <div className={styles.loginErrorMsg} role="alert">
            {error.message}
          </div>
        )}

        <Field type="input" name="New Password" error={error.password}>
          <i
            className={`icon-append fa ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
            style={{ cursor: 'pointer' }}
            onClick={() => setShowPassword(v => !v)}
            title={showPassword ? 'Hide password' : 'Show password'}
          />
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            placeholder="Enter new password"
            autoComplete="new-password"
            onChange={handlePasswordChange}
          />
        </Field>
        <PasswordStrengthRules password={passwordValue} />

        <Field type="input" name="Confirm Password" error={error.confirmPassword}>
          <i
            className={`icon-append fa ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
            style={{ cursor: 'pointer' }}
            onClick={() => setShowConfirmPassword(v => !v)}
            title={showConfirmPassword ? 'Hide password' : 'Show password'}
          />
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            name="confirmPassword"
            placeholder="Confirm new password"
            autoComplete="new-password"
            onChange={onChangeFactory('confirmPassword')}
          />
        </Field>
      </fieldset>

      <footer className={styles.footer}>
        <button
          type="submit"
          className={`btn btn-primary ${styles.submitButton}`}
          disabled={inProgress}
        >
          {inProgress ? 'Resetting...' : 'Reset Password'}
        </button>
        <div className={styles.footerLinks}>
          <Link to="/login">Back to Sign In</Link>
        </div>
      </footer>
    </form>
  )
}

export default ResetPasswordForm
